module.exports = __webpack_public_path__ + "static/oltp-vs-olap-79704ad42fca39c1839e824ffbb19071.png";